// @fow
import React from 'react';
import _ from 'lodash';
import styled, { withTheme } from 'styled-components';
import TextField from 'material-ui/TextField';
import { translate } from 'react-i18next';

const Icon = styled.i`
  color: ${({ theme }) => theme.colors.disabled};
`;

const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  ${({ theme }) => `
    background-color: ${theme.colors.cardBackground};
    padding-left: ${theme.metrics.smallMargin}px;
    padding-right: ${theme.metrics.margin}px;
    border-width: ${theme.metrics.tinyBorder}px;
    border-color: ${theme.colors.divider};
  `}
  
  border-style: solid;
`;

type Props = {
  onChange: (value: string) => void,
  value: string,
  theme: Object,

  rightIcon?: boolean,
  hintText?: string,
  hintStyle?: Object,
  extraStyle?: Object,
  t: any,
};

type State = {
  value: string,
}

const SEARCH_DEBOUNCE_IN_MS = 300;

class SearchBar extends React.Component<Props, State> {

  constructor(props: Props) {
    super(props);
    this.state = { value: props.value };
  }

  onSearchChangeCallback = _.debounce(this.props.onChange, SEARCH_DEBOUNCE_IN_MS);

  onSearchChange = (event: Object, value: string) => {
    this.setState({ value }, () => this.onSearchChangeCallback(value));
  };

  render() {
    const { rightIcon, hintText, hintStyle, theme, extraStyle, t } = this.props;
    const { value } = this.state;

    return (
      <Container>
        {!rightIcon && <Icon className="material-icons">search</Icon>}
        <TextField
          hintText={hintText || t('search')}
          onChange={this.onSearchChange}
          value={value}
          hintStyle={{ ...hintStyle }}
          style={{ paddingLeft: theme.metrics.smallMargin, overflow: 'hidden', ...extraStyle }}
          underlineShow={false}
          fullWidth
        />
        {rightIcon && <Icon className="material-icons">search</Icon>}
      </Container>
    );
  }
}

export default withTheme(translate()(SearchBar));



// WEBPACK FOOTER //
// ./src/common/components/SearchBar.js